import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IffhsService } from 'src/app/data-services/iffhs.service';
import { AuthenticationService } from 'src/app/data-services/authentication.service';
import { UserService } from 'src/app/data-services/user.service';
import { first } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-national-team-dashboard-media',
  templateUrl: './national-team-dashboard-media.component.html',
  styleUrls: ['./national-team-dashboard-media.component.css']
})
export class NationalTeamDashboardMediaComponent implements OnInit {

  mediaForm: FormGroup;
  id: number;
  teamClass: string;
  category: string;
  countryData: any = {};
  searchText: any;
  currentUser: any;
  isLoaderVisible = false;
  submitted = false;
  isSubmitted = true;
  errorMessage: string = '';
  onChangeValue = '';
  constructor(
    private route: ActivatedRoute,
    private iffhsService: IffhsService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private toastrService: ToastrService,

  ) { }

  ngOnInit(): void {
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    this.route.queryParams.subscribe(params => {
      this.id = params['id'];
      this.teamClass = params['name'];
      this.category = params['category'];
    });
    this.countryDetails();
    this.mediaForm = this.formBuilder.group({
      countryId: [this.id],
      mediaType: ['', Validators.required],
      mediaTitle: ['', Validators.required],
      mediaContent: ['', Validators.required],
      mediaAttachment: ['', Validators.required],
      createdBy: [this.currentUser.success.user.id],

    });
  }
  countryDetails() {
    this.isLoaderVisible = true;
    const data = {
      countryId: this.id,
    };
    this.iffhsService.getCountryDetails(data).pipe(first<any>())
      .subscribe(countryData => this.countryData = countryData[0]);
    this.isLoaderVisible = false;
  }
  onChange(e) {
    this.onChangeValue = e.target.value || 0;
    console.log(this.onChangeValue);
  }
  onImageSelect(event) {
    const mediaAttachment = event.target.files[0];
    const type = event.target.files[0].type;
    if (type.match(/image\/*/) === null) {
      this.toastrService.error('Only images are supported', 'Message!');
      return;
    }
    this.mediaForm.get('mediaAttachment').setValue(mediaAttachment);

  }
  onVideoSelect(event) {
    const mediaAttachment = event.target.files[0];
    const type = event.target.files[0].type;
    if (type.match(/video\/*/) === null) {
      this.toastrService.error('Only videos are supported', 'Message!');
      return;
    }
    this.mediaForm.get('mediaAttachment').setValue(mediaAttachment);

  }
  get f() { return this.mediaForm.controls; }
  postMedia() {
    this.submitted = true;
    if (this.mediaForm.invalid) {
      return;
    }
    this.isLoaderVisible = true;
    const fd = new FormData();
    fd.append('countryId', this.mediaForm.get('countryId').value);
    fd.append('mediaType', this.mediaForm.get('mediaType').value);
    fd.append('mediaTitle', this.mediaForm.get('mediaTitle').value);
    fd.append('mediaContent', this.mediaForm.get('mediaContent').value);
    fd.append('teamClass', this.teamClass);
    fd.append('teamClass', this.category);
    fd.append('mediaAttachment', this.mediaForm.get('mediaAttachment').value);
    fd.append('createdBy', this.mediaForm.get('createdBy').value);

    this.iffhsService.addMedia(fd).pipe(first()).subscribe(
      data => {
        this.isLoaderVisible = false;
        this.toastrService.success(this.onChangeValue + ' Added!', 'Message!');
        this.submitted = true;
      },
      error => {
        console.log(error);
        this.isLoaderVisible = false;
        this.toastrService.error('Something went wrong please Try Later!', 'Message!');

      }
    );
    this.resetForm();
  }
  resetForm() {
    this.mediaForm = this.formBuilder.group({
      countryId: [this.id],
      mediaType: [''],
      mediaTitle: [''],
      mediaContent: [''],
      mediaAttachment: [''],
      createdBy: [this.currentUser.success.user.id],
    });
  }


}
